import { render, staticRenderFns } from "./IrisSelectableTileContainer.vue?vue&type=template&id=e705ac3e&"
import script from "./IrisSelectableTileContainer.vue?vue&type=script&lang=ts&"
export * from "./IrisSelectableTileContainer.vue?vue&type=script&lang=ts&"
import style0 from "./IrisSelectableTileContainer.vue?vue&type=style&index=0&id=e705ac3e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports